import _extends from "@babel/runtime/helpers/esm/extends";
import { jsx as _jsx } from "react/jsx-runtime";
import { Components as ListComponents } from './typeaheadList.style';
import { forwardRef } from 'react';
import { MAX_MATCHES } from './typeahead.util';
export const TypeaheadMenu = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    onMouseEnter,
    onMouseLeave,
    maxListHeight,
    $hide,
    children
  } = props;
  //UL wrapper of typeahead
  return _jsx(ListComponents.Wrapper, _extends({
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    maxHeight: maxListHeight ? maxListHeight : MAX_MATCHES * 50 + 'px',
    "$hidden": $hide,
    ref: ref
  }, {
    children: children
  }));
});